export default __webpack_public_path__ + "static/media/main box5.504992ba.png";